import { createReducer } from "@reduxjs/toolkit";
import {
  FETCH_LAST_VISIT_SUCCESS,
  SET_COMMENT_LIST_TOP_IN_VIEWPORT,
  ADD_COMMENT_LOADING,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_FROM_EVENT_STREAM_SUCCESS,
} from "~/store/action_types";

const reducer = createReducer({}, (builder) => {
  builder
    .addCase(ADD_COMMENT_LOADING, (state, action) => {
      const { parentType, parentId, attributes } = action;
      const { created_on } = attributes;

      if (created_on) {
        const key = `${parentType}-${parentId}`;
        state = {
          ...state,
          [key]: {
            ...state[key],
            last_visit_timestamp: Number(created_on),
          },
        };
      }

      return state;
    })
    .addCase(ADD_COMMENT_SUCCESS, (state, action) => {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { comments = {} } = entities;
      const { single } = result;
      const comment = comments[single];

      if (comment) {
        const { parent_type, parent_id, created_on } = comment;
        const key = `${parent_type}-${parent_id}`;
        state = {
          ...state,
          [key]: {
            ...state[key],
            last_visit_timestamp: Number(created_on),
          },
        };
      }

      return state;
    })
    .addCase(ADD_COMMENT_FROM_EVENT_STREAM_SUCCESS, (state, action) => {
      if (!action.parentHasNewComments && action.prevent) {
        const { response = {}, parentType, parentId } = action;
        const { entities = {}, result } = response;
        const { comments = {} } = entities;
        const comment = comments[result];
        if (comment) {
          const { created_on } = comment;
          const key = `${parentType}-${parentId}`;
          const previous = state[key]?.last_visit_timestamp || 0;

          if (comment && created_on > previous) {
            state = {
              ...state,
              [key]: {
                ...state[key],
                last_visit_timestamp: Number(created_on) + 1,
              },
            };
          }
        }
      }

      return state;
    })
    .addCase(SET_COMMENT_LIST_TOP_IN_VIEWPORT, (state, action) => {
      const { objectType, id, value } = action;
      const key = `${objectType}-${id}`;
      state = {
        ...state,
        [key]: {
          ...state[key],
          comment_list_top_in_viewport: value,
        },
      };
      return state;
    })
    .addCase(FETCH_LAST_VISIT_SUCCESS, (state, action) => {
      const { response = {}, objectType, id } = action;
      const { last_visit_timestamp } = response;
      const key = `${objectType}-${id}`;
      if (last_visit_timestamp) {
        state = {
          ...state,
          [key]: {
            ...state[key],
            last_visit_timestamp: Number(last_visit_timestamp),
          },
        };
      }

      if ([`undefined`, null].indexOf(typeof action.value) === -1) {
        state = {
          ...state,
          [key]: {
            ...state[key],
            last_visit_timestamp: Number(action.value),
          },
        };
      }
      return state;
    });
});

export default reducer;
